<ejs-breadcrumb
  [items]="crumbs"
  [maxItems]="maxItems"
  (itemClick)="onClick($event)"
>
</ejs-breadcrumb>
